import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Modal,
  IconButton,
  Divider,
  TextField,
  CircularProgress
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import StarIcon from '@mui/icons-material/Star';
import { useConfirmModal } from './styles';

interface RatingModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (rating: number | null, comment?: string) => void;
  reload?: () => void;
  isOptional?: boolean;
  text:string
}

export const RatingModal: React.FC<RatingModalProps> = ({
  open,
  onClose,
  onConfirm,
  reload,
  isOptional,
  text
}) => {
  const styles = useConfirmModal();
  const [rating, setRating] = useState<number | null>(null);
  const [comment, setComment] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleRatingChange = (value: number) => {
    setRating(value);
    if (value > 2) setComment('');
  };

  const handleConfirm = async () => {
    if (!isOptional) {
      setIsSubmitting(true);
      try {
        if (rating !== null) {
          await onConfirm(rating, comment);
        }
        if (reload) {
          window.onbeforeunload = null;
          window.location.reload()
        }
        onClose();

      } catch (error) {
        console.error(error);
      } finally {
        setIsSubmitting(false);
      }
    } else {

      if (rating !== null) {
        setIsSubmitting(true);
      }
      try {
        await onConfirm(rating, comment);

        onClose();

      } catch (error) {
        console.error(error);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  return (
    <Modal open={open} /* onClose={() => !isSubmitting && onClose()} */>
      <Box sx={styles.container}>
        {isOptional &&
          <IconButton
            aria-label="close"
            onClick={onClose}
            disabled={isSubmitting}
            sx={styles.closeIcon}
          >
            <CloseIcon />
          </IconButton>
        }

        <Box sx={{ padding: 3 }}>
          <Typography variant="h6" component="h2" fontWeight={600} sx={{ mb: 4 }}>
            Cierre de solicitud
          </Typography>
          <Typography sx={styles.description}>
            {text}
          </Typography>

          <Box display="flex" justifyContent="center" mb={3}>
            {[1, 2, 3, 4, 5].map((value) => (
              <IconButton
                key={value}
                onClick={() => handleRatingChange(value)}
                sx={{
                  color: value <= (rating || 0) ? '#FFD700' : '#E0E0E0',
                  fontSize: 32
                }}
              >
                <StarIcon />
              </IconButton>
            ))}
          </Box>

          {rating !== null && rating <= 2 && (
            <TextField
              label="Comentario"
              multiline
              rows={3}
              fullWidth
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              sx={{ mb: 3 }}
            />
          )}
        </Box>

        <Divider sx={{ mt: 3, mb: 0, width: '100%' }} />

        <Box sx={styles.btnContainer}>
          {isOptional &&
            <Button
              onClick={onClose}
              disabled={isSubmitting}
              sx={styles.cancelBtn}
            >
              Cancelar
            </Button>
          }
          <Button
            onClick={handleConfirm}
            disabled={isSubmitting || rating === null || (rating <= 2 && !comment)}
            sx={styles.confirmBtn}
          >
            {isSubmitting ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              'Confirmar'
            )}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};